<template>
  <div>
    <!-- 微信 -->
    <div class="flex" v-if="selected === '1'">
      <div class="model wechat" @click="viewWxDetail(1)">
        <svg class="icon" aria-hidden="true" slot="icon">
          <use xlink:href="#icon-moment"></use>
        </svg>
        <span class="title">朋友圈推广海报</span>
      </div>
      <div class="model wechat" @click="viewWxDetail(2)">
        <svg class="icon" aria-hidden="true" slot="icon">
          <use xlink:href="#icon-wechatfriend"></use>
        </svg>
        <span class="title">好友推广海报</span>
      </div>
    </div>
    <!-- 表格 -->
    <div class="model table">
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
          <ul>
            <li class="flex nav-title">
              <div class="flex1 skyBlue">渠道</div>
              <div class="flex1 waterBlue">当天</div>
              <div class="flex1 skyBlue">本周</div>
              <div class="flex1 waterBlue">本月</div>
              <div class="flex1 skyBlue">累计</div>
            </li>
            <li class="flex nav-title" v-for="(item, index) in channelList.list.filter(s => (s.channelType !== 'blog'))" :key="index">
              <div class="flex1">{{ item.name }}</div>
              <div class="flex1">{{ channelList.overviews.find(t => t.channelKey === item.channelKey).day.count }}</div>
              <div class="flex1">{{ channelList.overviews.find(t => t.channelKey === item.channelKey).week.count }}</div>
              <div class="flex1">{{ channelList.overviews.find(t => t.channelKey === item.channelKey).month.count }}</div>
              <div class="flex1">{{ channelList.overviews.find(t => t.channelKey === item.channelKey).all.count }}</div>
            </li>
            <li class="flex nav-title tooltip">
              提示：请根据你实际转发的情况决定进入哪个海报，这样能提高数据分析的准确性
            </li>
          </ul>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <!-- 更精准的流量提示 -->
    <div class="model moreTooltip center" v-if="selected === '1'">
      <mt-button class="save" @click="more">更精准的流量</mt-button>
      <p class="more">
        微信分 享已满足不了你资源多的你？
        <br />
        可以试一下通过贴子，微博，服务号文章等方式分 享。
        <br />
        为了方便统计流量，建议不同的帖子使用不同的渠道。
      </p>
    </div>

    <!-- 帖子 -->
    <div v-show="selected === '2'">
      <div class="model table" style="margin-top: 0.32rem;">
        <div class="label">
          <p :class="fansBy === 'day' ? 'select' : ''" @click="() => selectFansBy('day')">
            按天
          </p>
          <p :class="fansBy === 'week' ? 'select' : ''" @click="() => selectFansBy('week')">
            按周
          </p>
          <p :class="fansBy === 'month' ? 'select' : ''" @click="() => selectFansBy('month')">
            按月
          </p>
        </div>

        <br />
        <!-- 报表 -->
        <div class="flex model_body flex" v-show="selected === '2'">
          <!-- <p class="echartsTitle">流量转化</p> -->
          <!-- 背景图 -->
          <div class="data-table flex1 background" id="channel">
            暂无更多数据
          </div>
          <!-- <p class="echartAxis">渠道</p> -->
        </div>
      </div>
    </div>

    <!-- 渠道 -->
    <div v-show="selected === '2'" v-for="(item, index) in channelList.list
                .filter(s => (s.channelType === 'blog'))" :key="index">
      <div class="model" style="height: auto;">
        <div class="model_header">
          <div class="flex">
            <div class="flex1 text-align-left">
              <input maxlength="7" v-if="item.edit" type="text" :value="item.name" :ref="'input-' + item.id" @blur="blur" @input="changeName" class="noBorder">
              <span v-if="!item.edit" class="model_title">{{ item.name }}</span>
              <a v-if="!item.edit" class="link" @click="onEdit(item.id)">修改</a>
              <a v-if="item.edit" class="link" @click="() => confirmChannelName(item.id)">确定</a>
            </div>
          </div>
        </div>
        <div class="flex model_body flex">
          <div class="data-table flex1 code">
            <span>
              {{ item.code }}
            </span>
            <!--@click="() => copyLink(item.code)"-->
            <div class="btn-wrap">
              <a class="linkButton" v-clipboard:copy="path + item.code" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</a>
              <a class="linkButton" @click="getQrImg(path + item.code)">二 维 码</a>
            </div>

            <br />
            <br />
            <p class="linkTip">{{path + item.code}}</p>
          </div>
        </div>
        <div class="flex model_body flex">
          <div class="data-table flex1 codeTip">
            <p>开封日期：{{ formate(item.createDate) }}</p>
            <p class="blod"><span class="normal">流量：</span>{{ channelList.overviews.find(t => t.channelKey === item.channelKey).day.count }}(今天)/&nbsp;{{ channelList.overviews.find(t => t.channelKey === item.channelKey).week.count }}(本周)/&nbsp;{{ channelList.overviews.find(t => t.channelKey === item.channelKey).month.count }}(当月)/&nbsp;{{ channelList.overviews.find(t => t.channelKey === item.channelKey).all.count }}(全部)</p>
            <!--<p class="blod"><span class="normal">转化：</span>{{ channelList.overviews.find(t => t.channelKey === item.channelKey).day.count }}(今天)/&nbsp;{{ channelList.overviews.find(t => t.channelKey === item.channelKey).week.count }}(本周)/&nbsp;{{ channelList.overviews.find(t => t.channelKey === item.channelKey).month.count }}(当月)/&nbsp;{{ channelList.overviews.find(t => t.channelKey === item.channelKey).all.count }}(全部)</p>-->
            <p>&nbsp;</p>
          </div>
        </div>
      </div>
    </div>

    <!-- addChanel -->
    <div v-show="selected === '2'" class="buttonComtainer">
      <mt-button class="save" @click="addChanel">+ 添加渠道</mt-button>
    </div>
    <mt-popup v-model="showPopup" popup-transition="popup-fade">
      <div class="popup-tips">长按二维码保存</div>
      <div class="canvas-wrap">
        <qriously :value="qrImgUrl" :size="200" :backgroundAlpha="1"></qriously>
        <img :src="b64img" />
      </div>
    </mt-popup>
    <!-- 占位符 -->
    <div style="height: 50px" />

  </div>
</template>

<script>
import 'echarts/lib/chart/bar';
import { formate, echartsConfig } from '../../utils/utils';
import { Toast } from 'mint-ui';
import SiteEnv from '../../utils/siteEnv';

export default {
  props: [
    'changeType',
    'channelList',
    'selected',
    'editChannelName',
    'confirmChannelName',
    'blur',
    'changeName',
    'addChanel',
  ],
  name: 'Table',
  created() {
    this.formate = formate;
  },
  watch: {
    selected: function(value) {
      if (value === '2')
        setTimeout(() => {
          this.init();
        });
    },
  },
  data() {
    return {
      path: SiteEnv.showHome() + '?ivt=',
      fansBy: 'day',
      showPopup: false,
      qrImgUrl: '',
      b64img: '',
      channel: {
        axis: [],
        value: [],
      },
    };
  },
  methods: {
    getQrImg(url) {
      this.qrImgUrl = url;
      setTimeout(() => {
        this.b64img = document.querySelector('.canvas-wrap canvas').toDataURL();
        this.showPopup = true;
      });
    },
    onEdit(id) {
      this.editChannelName(id);
      setTimeout(() => {
        this.$refs['input-' + id][0].focus();
      });
    },
    onError() {
      Toast('复制失败了');
    },
    onCopy() {
      Toast('复制成功');
    },
    more() {
      document.getElementById('tab2').click();
    },
    viewWxDetail: function(item) {
      this.$router.push({ path: '/user/poster', query: { selected: item } });
      //        this.$router.push('/user/poster');
    },
    selectFansBy: function(value) {
      this.fansBy = value;
      this.init();
    },
    getFilter: function(value, axis) {
      const total = value.reduce((s, t) => s + t, 0);
      return value
        .map((s, index) => ({ value: s, name: axis[index] }))
        .filter((s, index) => index < echartsConfig.minNumber)
        .filter((s, index) => s.value / total > echartsConfig.minPercent)
        .sort(function(a, b) {
          return a.value - b.value;
        });
    },
    init: function() {
      // 获取报表数据
      const axis = [];
      const value = [];
      this.channelList.list.filter(t => t.channelType === 'blog').map(s => {
        axis.push(s.name);
        value.push(
          this.channelList.overviews.find(m => m.channelKey === s.channelKey)[
            this.fansBy
          ].count
        );
      });
      const total = value.reduce((s, t) => s + t, 0);
      const container = document.getElementById('channel');
      let myEcharts = this.$echarts.init(container);
      let option = {
        width: '85%',
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)',
        },
        grid: {
          x: 30,
          y: 30,
        },
        series: [
          {
            type: 'pie',
            labelLine: {
              normal: {
                length: 8,
                length2: 10,
              },
            },
            data: this.getFilter(value, axis),
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#334B5C', '#D53A35', '#7FAE90', '#9FDABF'];
                  return colorList[(params.dataIndex + 1) % 4];
                },
              },
            },
          },
        ],
      };
      myEcharts.setOption(option);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.canvas-wrap {
  position: relative;
}
.canvas-wrap > canvas {
  opacity: 0;
}
.canvas-wrap > img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.popup-tips {
  text-align: center;
  font-size: 0.16rem;
  margin: 5px;
}
.normal {
  font-weight: 400 !important;
}
.blod {
  font-weight: 600;
}
.buttonComtainer {
  text-align: center;
}
.save {
  margin: auto;
  border-color: #009688;
  background: #fff;
  color: #009688;
}
.model {
  height: 0.5rem;
}
.wechat {
  margin: 0.15rem;
  line-height: 0.5rem;
  font-size: 0.16rem;
  text-align: center;
}
ul {
  padding-left: 0px;
  text-align: center;
  font-size: 0.16rem;
  line-height: 0.26rem;
  margin: 0;
}
li {
  border-bottom: 1px solid #cdcdcd;
}
li div {
  padding-top: 5px;
  padding-bottom: 5px;
}
.table {
  height: unset;
}
.tooltip {
  color: #7f7f7f;
  padding: 10px;
  text-align: left;
}
.more {
  padding: 12px;
  text-align: left;
}
.moreTooltip {
  height: unset;
  padding: 15px 0;
}
.top {
  padding-top: 0.15rem;
  padding-left: 0.3rem;
}
.dateDetail {
  text-align: center;
  justify-content: space-around;
  padding: 0.1rem 0;
}
.dateDetail p {
  color: #7f7f7f;
}
.label {
  display: flex;
  padding-top: 0.2rem;
  margin-left: 50%;
}
.label p {
  padding: 0.02rem 0.1rem;
  color: #009688;
  border: 1px solid #009688;
}
.label p:nth-child(1) {
  border-right: none !important;
  border-radius: 0.05rem 0 0 0.05rem;
}
.label p:nth-child(3) {
  border-left: none !important;
  border-radius: 0 0.05rem 0.05rem 0;
}
.select {
  color: #fff !important;
  background: #009688;
}
#channel {
  height: 2rem;
}
.link {
  font-size: 0.16rem;
}
.code {
  margin-top: 10px;
  margin-bottom: 10px;
}
.code span {
  font-size: 0.25rem;
}
.btn-wrap {
  float: right;
}
.linkButton {
  font-size: 0.16rem;
  border: 1px solid #009688;
  border-radius: 4px;
  padding: 5px;
  color: #009688;
  display: block;
}
.linkButton:first-child {
  margin-bottom: 10px;
}
.linkTip {
  color: #009688;
}
.codeTip p {
  margin-top: 3px;
  color: #777777;
}
.flex svg {
  margin-top: 0.13rem;
}
.title {
  position: relative;
  top: -2px;
}
.echartsTitle {
  display: inline;
  position: absolute;
}
.echartAxis {
  display: inline;
  position: absolute;
  right: 0.3rem;
  margin-top: 1.3rem;
}
.noBorder {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.background {
  background: url('../../../static/img/empty.png') no-repeat center 30% !important;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/userChannelElement/Table.vue